(function () {
  class ReelFireball extends PIXI.Container {
    constructor() {
      super();

      messageBus.subscribe(
        "spinner:GameConfigEvent",
        this.onGameConfigEvent.bind(this)
      );
    }

    findChild(parent, name) {
      const child = parent.find(function (child) {
        return child.Props.ID === name;
      });
      return child;
    }

    onGameConfigEvent() {
      this._fireball = this.findChild(this.children[0].children, "fireball");
      this._fireball.gotoAndStop(0);
      this._fireball.visible = false;
      this._glow = this.findChild(this.children[0].children, "glow");
      this._glow.visible = false;
      this._text = this.findChild(this.children[0].children, "value");
      this._text.visible = false;
      this._blazingBounty = this.findChild(
        this.children[0].children,
        "blazingBounty"
      );
      this._blazingBounty.visible = false;
      this._extraHot = this.findChild(this.children[0].children, "extraHot");
      this._extraHot.gotoAndStop(0);
      this._extraHot.visible = false;
      this._respinPlus = this.findChild(
        this.children[0].children,
        "respinPlus"
      );
      this._respinPlus.visible = false;
      this._respinPlusText = this.findChild(
        this.children[0].children,
        "respinText"
      );
      this._respinPlusText.visible = false;
    }

    animate(isWildFire, callback, fireBallPos, isBG) {
      const self = this;
      if (!this.callbackComplete && this.fireballTween) {
        this.fireballTween.kill();
        this.fireballCallback();
      }
      this.visible = true;
      this.callbackComplete = false;
      this.fireballCallback = callback;
      const fireball = this._fireball;
      fireball.visible = true;
      fireball.gotoAndPlay(0);
      const startPos = fireBallPos;
      self.position.set(startPos.x, startPos.y);
      this.fireballTween = gsap
        .timeline()
        .to(fireball.scale, {
          duration: 0.25,
          x: 0.8,
          repeat: 1,
          yoyo: true,
          onStart: () => {
            self._glow.visible = true;
            self._glow.alpha = 0;
            gsap.to(self._glow, {
              duration: 0.2,
              alpha: 0.8,
            });
          },
          onComplete: () => {
            gsap.to(fireball.scale, {
              duration: 0.15,
              x: 0.8,
            });
            if (isBG) {
              soundManager.play("fireballWhoosh");
            }
          },
        })
        .to(self.position, {
          duration: 0.4,
          ease: "power1.out",
          y: -900,
          onComplete: () => {},
        })
        .to(self.position, {
          duration: 0.05,
          onStart: () => {
            self.position.x = layoutController.getCurrentPosition(
              "slotContainer:reelFireballs:endPos"
            ).x;
            self.position.y =
              layoutController.getCurrentPosition(
                "slotContainer:reelFireballs:endPos"
              ).y - 900;
          },
          onComplete: () => {
            timerManager.addTimer(
              100,
              function (progress) {},
              function () {
                self._glow.visible = false;
                self._glow.alpha = 1;
                self.callbackComplete = true;
                self._fireball.visible = false;
                callback();
              }
            );
          },
        });
    }

    landOnReels(callback, fireBallPos) {
      const self = this;
      const fireball = this._fireball;
      fireball.visible = true;
      fireball.gotoAndPlay(0);
      fireball.scale.x = 0.8;
      const startPos = { x: fireBallPos.x, y: -1000 };
      self.position.set(startPos.x, startPos.y);
      gsap
        .timeline()
        .to(self.position, {
          duration: 0.3,
          ease: "power1.out",
          y: fireBallPos.y,
        })
        .to(fireball.scale, {
          duration: 0.1,
          x: 1,
          y: 0.6,
          ease: "power1.out",
          onComplete: () => {
            fireball.visible = false;
            fireball.scale = { x: 1, y: 1 };
            callback();
          },
        });
    }

    doBlazingBountyActivation(index, reel, fireBallStartPos, callback) {
      const self = this;
      self.visible = true;
      const fireball = this._fireball;
      const BB = this._blazingBounty;
      BB.visible = true;
      const startPos = fireBallStartPos;
      self.position.set(startPos.x, startPos.y);
      soundManager.play("blazingBountyActivate");
      BB.gotoAndStop(0);
      BB.onComplete = () => {
        fireball.visible = false;
        BB.visible = false;
        callback();
      };
      BB.play();
    }

    doBlazingBountyMerge(
      symbol,
      value,
      fireBallStartPos,
      fireBallEndPos,
      delay,
      movementTime,
      callback
    ) {
      soundManager.play("blazingBountyWoosh");
      const self = this;
      const fireball = this._fireball;
      fireball.scale = { x: 1, y: 1 };
      const text = this._text;
      text.setText(value);
      fireball.visible = true;
      text.visible = true;
      fireball.gotoAndPlay(0);
      self.position.set(fireBallStartPos.x, fireBallStartPos.y);
      timerManager.addTimer(delay, undefined, function () {
        symbol.setReelSymbol(0, 17);
        gsap.to(fireball.scale, {
          duration: 0.6,
          x: 0.2,
        });
        gsap.to(text.scale, {
          duration: 0.6,
          x: 0.2,
        });
        gsap.timeline().to(self.position, {
          duration: movementTime,
          ease: "power1.in",
          y: fireBallEndPos.y,
          onComplete: () => {
            fireball.scale = { x: 1, y: 1 };
            text.scale = { x: 1, y: 1 };
            fireball.visible = false;
            text.visible = false;
            callback();
          },
        });
      });
    }

    doBlazingBountyMergeCashValueTextMove(
      cashValueStartPos,
      cashValueEndPos,
      textValue,
      callback
    ) {
      soundManager.play("fireballWhooshDown");
      const self = this;
      this.visible = true;
      const text = this._text;
      text.setText(textValue);
      text.visible = true;
      text.scale = { x: 1, y: 1 };
      this._fireball.visible = false;
      const startPos = cashValueStartPos;
      self.position.set(startPos.x, startPos.y);
      gsap.to(self.position, {
        duration: 0.4,
        ease: "power1.inOut",
        x: cashValueEndPos.x,
        y: cashValueEndPos.y,
        onComplete: () => {
          self._fireball.visible = false;
          self._fireball.scale = { x: 1, y: 1 };
          text.scale = { x: 1, y: 1 };
          text.visible = false;
          callback();
        },
      });
    }

    reactToMerge(cashValueStartPos, value, endValue, callback) {
      const self = this;
      const fireball = this._fireball;
      const text = this._text;
      const start = value;
      const end = start + endValue;
      this.visible = true;
      text.visible = true;
      fireball.visible = true;

      timerManager.addTimer(
        100,
        function (progress) {
          const val = Math.floor(start + (end - start) * progress);
          text.setText(
            PartnerConnect.PreparedObjectsFactory.getCurrencyFormatter().formatDecimal(
              val / 100
            )
          );
        },
        function () {
          text.setText(
            PartnerConnect.PreparedObjectsFactory.getCurrencyFormatter().formatDecimal(
              endValue / 100
            )
          );
        }
      );
      //text.setText(textValue);
      const startPos = cashValueStartPos;
      self.position.set(startPos.x, startPos.y);
      gsap
        .timeline()
        .to(fireball.scale, {
          duration: 0.1,
          x: 1.2,
          y: 1.2,
        })
        .to(fireball.scale, {
          duration: 0.1,
          x: 1,
          y: 1,
          onComplete: () => {
            fireball.scale = { x: 1, y: 1 };
            text.scale = { x: 1, y: 1 };
            fireball.visible = false;
            text.visible = false;
            callback();
          },
        });
    }

    animateBlazingBounty(fireBallStartPos, textValue, callback) {
      const self = this;
      const fireball = this._fireball;
      this.visible = true;
      fireball.visible = true;
      fireball.gotoAndPlay(0);
      const text = this._text;
      text.setText(textValue);
      text.visible = true;
      const startPos = fireBallStartPos;
      self.position.set(startPos.x, startPos.y);
      gsap
        .timeline()
        .to(fireball.scale, {
          duration: 0.2,
          x: 1.2,
          y: 1.2,
          ease: "bounce.inOut",
        })
        .to(fireball.scale, {
          duration: 0.2,
          x: 1,
          y: 1,
          ease: "bounce.inOut",
          onComplete: () => {
            fireball.scale = { x: 1, y: 1 };
            text.scale = { x: 1, y: 1 };
            fireball.visible = false;
            text.visible = false;
            callback();
          },
        });
    }

    doExtraHotActivation(fireBallStartPos, callback) {
      const self = this;
      const extraHot = this._extraHot;
      extraHot.visible = true;
      const startPos = fireBallStartPos;
      self.position.set(startPos.x, startPos.y);
      extraHot.loop = false;
      extraHot.gotoAndStop(0);
      extraHot.play();
      extraHot.onComplete = () => {
        extraHot.visible = false;
        extraHot.onComplete = undefined;
        callback();
      };
    }

    doExtraHotMove(extraHotStartPos, delay, callback) {
      const self = this;
      this.visible = true;
      const extraHot = this._extraHot;
      timerManager.addTimer(delay, undefined, function () {
        extraHot.visible = true;
        extraHot.gotoAndPlay(0);

        self.position.copy(extraHotStartPos);
        const originalExtraHotIndex = self.children[0].getChildIndex(extraHot);
        gameController.blazingMultiplierContainer.children[0].addChildAt(
          extraHot,
          4
        );

        const startPosition = gameController.blazingMultiplierContainer.toLocal(
          self.toGlobal(systemData.stage)
        );
        extraHot.position = startPosition;

        self.extraHotMoveProgress = 0;
        gsap.to(self, {
          extraHotMoveProgress: 100,
          duration: 0.5,
          ease: "power1.in",
          onUpdate: () => {
            const startPosition =
              gameController.blazingMultiplierContainer.toLocal(
                self.toGlobal(systemData.stage)
              );
            const endPosition = { x: 75, y: 60 };
            const xDiff =
              ((endPosition.x - startPosition.x) * self.extraHotMoveProgress) /
              100;
            const yDiff =
              ((endPosition.y - startPosition.y) * self.extraHotMoveProgress) /
              100;
            const scaleDiff = (0.4 * self.extraHotMoveProgress) / 100;
            extraHot.x = startPosition.x + xDiff;
            extraHot.y = startPosition.y + yDiff;
            extraHot.scale = { x: 1 - scaleDiff, y: 1 - scaleDiff };
          },
          onComplete: () => {
            callback();
            timerManager.addTimeout(200, () => {
              self._fireball.visible = false;
              extraHot.scale.set(1, 1);
              extraHot.visible = false;
              extraHot.x = 0;
              extraHot.y = 0;
              self.children[0].addChildAt(extraHot, originalExtraHotIndex);
            });
          },
        });
      });
    }

    doRespinPlusActivation(fireBallStartPos, callback) {
      const self = this;
      const respinPlus = this._respinPlus;
      respinPlus.visible = true;
      const startPos = fireBallStartPos;
      this._fireball.visible = false;

      self.position.set(startPos.x, startPos.y);
      respinPlus.loop = false;
      respinPlus.gotoAndStop(0);
      respinPlus.play();
      respinPlus.onComplete = () => {
        respinPlus.visible = false;
        respinPlus.onComplete = undefined;
        callback();
      };
    }

    doRespinPlusMove(extraHotStartPos, delay, callback) {
      const self = this;
      soundManager.play("plusOneTransition");
      const respinPlus = this._respinPlusText;
      this._fireball.visible = false;
      const endPosX =
        gameController.firelink.position.x +
        gameController.firelink._livesTextLabel.position.x;
      const endPosY =
        gameController.firelink.position.y +
        gameController.firelink._livesTextLabel.position.y;
      timerManager.addTimer(delay, undefined, function () {
        respinPlus.visible = true;
        //respinPlus.gotoAndPlay(0);
        const startPos = extraHotStartPos;
        self.position.set(startPos.x, startPos.y);
        gsap.timeline().to(self.position, {
          duration: 0.5,
          ease: "power1.in",
          x: endPosX,
          y: endPosY,
          onComplete: () => {
            respinPlus.visible = false;
            callback();
          },
        });
      });
    }
  }

  var creator = function (json) {
    return new ReelFireball();
  };

  var initialiser = function (json, reelFireball) {};

  var filesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType(
    "reelFireball",
    creator,
    initialiser,
    filesRequired
  );
})();
